export const rateTypeMapping = {
  all_in: 'All-In',
  line_haul: 'Line Haul',
}

export const RATE_TYPE_OPTIONS = Object.entries(rateTypeMapping).map(([key, value]) => ({
  label: value,
  value: key,
}))
